<template>
    <div class="main-div">
        <div class="tile-card">
            <p class="card-number">{{ cardNumber1 }}</p>
            <p class="card-heading">{{ cardHeading1 }}</p>
            <p class="cardSub-heading">{{ cardSubHeading1 }}</p>
            <p class="card-title">{{ heading1 }}</p>
            <p class="card-subtitle">{{ subheading1 }}</p>
        </div>
        <div class="tile-card">
            <p class="card-number">{{ cardNumber2 }}</p>
            <p class="card-heading">{{ cardHeading2 }}</p>
            <p class="cardSub-heading">{{ cardSubHeading2 }}</p>
            <p class="card-title">{{ heading2 }}</p>
            <p class="card-subtitle">{{ subheading2 }}</p>
        </div>
        <div class="tile-card">
            <p class="card-number">{{ cardNumber3 }}</p>
            <p class="card-heading">{{ cardHeading3 }}</p>
            <p class="cardSub-heading">{{ cardSubHeading3 }}</p>
            <p class="card-title">{{ heading3 }}</p>
            <p class="card-subtitle">{{ subheading3 }}</p>
        </div>
        <!-- <div class="tile-card2">
          
        </div> -->
    </div>
</template>
<script>
export default {
    name: "statisticCard",
    props: [
        "heading1",
        "heading2",
        "heading3",
        "subheading1",
        "subheading2",
        "subheading3",
        "cardNumber1",
        "cardHeading1",
        "cardSubHeading1",
        "cardNumber2",
        "cardHeading2",
        "cardSubHeading2",
        "cardNumber3",
        "cardHeading3",
        "cardSubHeading3",
    ],
};
</script>
<style lang="scss" scoped>
.main-div {
    // width:73%;
    max-width: 973px;
    margin: 0px auto;
gap:12px;
    display: flex;
}
.tile-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 191px;
    align-items: center;
    width: 33%;
    margin: 0px auto;
    background-color: #f8f9f8;
    border-radius: 12px;
}
@media all and (max-width: 1024px) {
    .main-div {
        display: flex;
        flex-direction: column;
        gap: 14px;
    }
}
@media all and (max-width: 1024px) {
    .tile-card {
        width: 90%;
       
    }
}
.card-title {
    font-weight: 500;
    font-size: 40px;
    text-align: center;
    color: #3a3f3a;
    margin-bottom: 0px;
}
.card-subtitle {
    width: 90%;
    font-weight: 400;
    font-size: 20px;
    margin: 0px auto;
    text-align: center;
    color: #797e79;
}
.card-number {
    font-weight: 500;
    font-size: 24px;
    line-height: 33px;
    /* identical to box height */
    margin-bottom: 5px;
    display: flex;
    // fle
    width: 90%;

    color: #3a3f3a;
}
.card-heading {
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    display: flex;
    align-items: center;
    width: 90%;
    margin-bottom: 5px;

    color: #3a3f3a;
}
.cardSub-heading {
    font-weight: 300;
    font-size: 18px;
    line-height: 130%;
    /* or 26px */
    margin-bottom: 0px;
    width: 90%;
    display: flex;
    align-items: center;

    color: #797e79;
}
.tile-card2 {
    display: flex;
    flex-direction: column;
    // justify-content: center;
    height: 191px;
    align-items: center;
    width: 33%;
    margin: 0px auto;
    background-color: #f8f9f8;
    border-radius: 12px;
}
@media all and (max-width: 1024px) {
    .cardSub-heading {
        font-size: 16px;
    }
}
</style>
